export default function unsetSelectedFilesInView({ state }) {
  const files = state.get('media.selectedFiles')
  files.forEach(mediaId => {
    state.unset(`media.files.${mediaId}`)
  })

  return { count: files.length }
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/unsetSelectedFilesInView.js